"use client";

import { useTranslation } from "react-i18next";
import Link from "next/link";
import Image from "next/image";
import logo from "@/assets/img/logo/HTU Logo.svg";
import FooterSocial from "@/components/footer/footer-social";
import { CloseThreeSvg } from "@/components/svg";
import OffcanvasMenu from "./offcanvas-menu";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { getLocalizedPath, ifArabic } from "@/utils/language";
import { useLanguage } from "@/app/[lang]/client/language-context";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

type IProps = {
  openOffCanvas: boolean;
  onHandleOffCanvas: () => void;
  offcanvas_cls?: string;
  headerTwo?: boolean;
};

export default function OffcanvasArea({
  openOffCanvas,
  onHandleOffCanvas,
  offcanvas_cls,
  headerTwo = false,
}: IProps) {
  const { t } = useTranslation();
  const { language } = useLanguage();
  const [value, setValue] = useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <>
      <div
        className={`offcanvas__area ${offcanvas_cls} ${
          openOffCanvas ? "offcanvas-opened" : ""
        }`}
      >
        <div className="offcanvas__wrapper">
          <div className="offcanvas__close">
            <button
              onClick={onHandleOffCanvas}
              className="offcanvas__close-btn offcanvas-close-btn"
              aria-label="Close Offcanvas Menu"
            >
              <CloseThreeSvg />
            </button>
          </div>

          <div className="offcanvas__content">
            <div className="offcanvas__top mb-20 d-flex justify-content-between align-items-center">
              <div className="offcanvas__logo tp-header-logo">
                <Link aria-label="Logo" href={getLocalizedPath("/", language)}>
                  <Image src={logo} alt={t("offcanvas.logo_alt")} />
                </Link>
              </div>
            </div>

            {!headerTwo && (
              <div className="mb-20 d-flex justify-content-center align-items-center">
                <Tabs
                  value={value}
                  onChange={handleChange}
                  textColor="inherit"
                  variant="fullWidth"
                  sx={{
                    "& .MuiTabs-indicator": {
                      backgroundColor: "#373737",
                    },
                  }}
                >
                  <Tab
                    label={t("offcanvas.nav")}
                    {...a11yProps(0)}
                    sx={{
                      color: "#000000", // dark gray, ~7:1 on white
                      fontFamily: ifArabic("GE Thameen", "ScalaSansPro"),
                    }}
                  />
                  <Tab
                    label={t("offcanvas.portals")}
                    {...a11yProps(1)}
                    sx={{
                      color: "#000000",
                      fontFamily: ifArabic("GE Thameen", "ScalaSansPro"),
                    }}
                  />
                </Tabs>
              </div>
            )}

            <CustomTabPanel value={value} index={0}>
              <div className="offcanvas-main">
                <OffcanvasMenu
                  onHandleOffCanvas={onHandleOffCanvas}
                  headerTwo={headerTwo}
                />
                <Link
                  aria-label={t("offcanvas.apply_now")}
                  className="tp-btn menu-button"
                  href={"https://sis.htu.edu.jo/new/"}
                  target={"_blank"}
                >
                  {t("offcanvas.apply_now")}
                </Link>
                <div className="offcanvas-social">
                  <h3 className="offcanvas-title sm">
                    {t("offcanvas.follow")}
                  </h3>
                  <div className="tp-footer-4-social">
                    <FooterSocial />
                  </div>
                </div>
              </div>
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              <OffcanvasMenu
                type="portals"
                onHandleOffCanvas={onHandleOffCanvas}
                headerTwo={headerTwo}
              />
              <div className="offcanvas-social offcanvas-main">
                <h3 className="offcanvas-title sm">{t("offcanvas.follow")}</h3>
                <div className="tp-footer-4-social">
                  <FooterSocial />
                </div>
              </div>
            </CustomTabPanel>
          </div>
        </div>
      </div>

      <div
        onClick={onHandleOffCanvas}
        className={`body-overlay ${openOffCanvas ? "opened" : ""}`}
      />
    </>
  );
}
